import React from "react";
import * as R from "ramda";
import { Div } from "components/Base";
import { connect } from "react-redux";
// import { isEmptyOrNil } from "utils/General";
import styleSpects from "components/Base/Base/styleSpecs";
import Avatar from "Portal/NewPortal/Shared/Avatar";
import { noop } from "utils/General";
import * as PortalSelectors from "redux/modules/portal/selectors";

const decorate = connect(
  state => ({
    portal: PortalSelectors.portal(state)
  }),
  {}
);

const MenuItem = ({ rightIcon = "", avatar = {}, onClick = noop }) => (
  <Div
    fs={2}
    px={5}
    py={2.5}
    onClick={onClick}
    display="row.space-between.center"
    bg={{
      hover: "neutral0",
      default: "white"
    }}
    color="gray7"
    style={{ cursor: "pointer" }}
    height={48}
  >
    <Div display="row.flex-start.center" style={{ gap: "6px" }}>
      {avatar && <Avatar {...avatar} longInitials />}

      <div
        style={{
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer"
        }}
      >
        {avatar?.name}
      </div>
    </Div>
    {rightIcon && (
      <i
        className={`material-icons-outlined check`}
        style={{ color: "#4263EB", fontSize: styleSpects.fontSize[2] }}
      >
        check
      </i>
    )}
  </Div>
);

const SwitchPortals = ({ portal = {}, handleClose = noop }) => {
  const { events = [], event = {} } = portal;
  const { id: eventId, uuid: eventUuid } = event;

  return (
    <Div display="column" width={1} style={{ gap: "12px" }} pb={4}>
      <Div>
        {R.map(
          ({ id, name, uuid, slug }) => (
            <MenuItem
              key={uuid}
              rightIcon={id === eventId && uuid === eventUuid ? "check" : null}
              onClick={() => {
                window.location.href = `/portals/${slug}/${uuid}`;
                handleClose();
              }}
              avatar={{ name, id }}
            />
          ),
          events
        )}
      </Div>
    </Div>
  );
};

export default decorate(SwitchPortals);
